<template>
  <validation-observer
    v-if="showTypeExperience"
    v-show="isRenderAfterFullfilled"
    v-slot="observer"
    slim
  >
    <form-section
      id="type-experience"
      :validated="formObserver.validated"
      v-bind="observer"
    >
      <form-row
        label="Have you been regularly driving a car not insured by you?"
        help-text="This would be regular driving of any car where you are not the main policyholder."
        :error="formObserver.validated && !observer.valid"
      >
        <validation-provider
          v-slot="{ errors }"
          :vid="`${stepId}_type-experience`"
          name="Experience Type"
          :rules="{
            listOptionRequired: showTypeExperience,
          }"
        >
          <qz-select
            v-model="questionData.typeExperience"
            :data-test="fieldTrackerId"
            :items="typeExperienceOptions"
            :error-messages="errors"
            :placeholder="helpers.getPlaceholderResponsiveText('Please select', isMobile)"
          />
        </validation-provider>
      </form-row>
    </form-section>
  </validation-observer>
</template>

<script>
import QuestionBase from './Base';
import { snakeCase } from 'lodash';

export default {
  name: 'question-type-experience',
  extends: QuestionBase,
  data () {
    return {
      fields: ['typeExperience'],
    };
  },
  computed: {
    showTypeExperience () {
      return this.stepData.noClaimsBonus === 0;
    },
    typeExperienceOptions () {
      return this.helpers.createOptions({ source: this.constants.COVER_TYPE_EXPERIENCE });
    },
    fieldTrackerId () {
      return snakeCase(this.questionFields.typeExperience);
    },
  },
  created () {
    this.$watch('showTypeExperience', val => {
      this.questionData.typeExperience = val ? this.defaultValues.typeExperience : null;
    });
  },
};
</script>
